/**
 * @description Checks if the user has only video admin scopes
 * @param tokenScopeItem
 * @returns {boolean} True if the user has only video admin scopes, false otherwise.
 */
export const isVideoOnlyUser = (
  tokenScopeItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >,
) => {
  if (!tokenScopeItem) return false;
  const { org, scope, user } = tokenScopeItem;

  const videoAdminScopes = [
    `o${org?.id}-videoAdmin:w`,
    `o${org?.id}-videoAdmin:r`,
  ];

  const userScope = `user${user?.id}`;

  const filteredScopes = scope?.filter(
    (scopeItem) => !scopeItem.includes(userScope),
  );

  return (
    (filteredScopes?.length ?? 0) > 0 &&
    filteredScopes?.every((scopeItem) => videoAdminScopes.includes(scopeItem))
  );
};
